import { ReactNode } from "react";
import { Navigate } from "react-router";
import { useCrmAccess } from "@/lib/permissionUtils";

/** Guards CRM pages that the deals-only (view-only) CRM level can't open, e.g. via a typed URL. */
export default function CrmFullOnly({ children }: { children: ReactNode }) {
  return useCrmAccess() === "full" ? <>{children}</> : <Navigate to="/crm/deals" replace />;
}
